import { ErrorState } from "@/components/feedback/ErrorState";
import type { TableStateProps } from "./DataTable.types";

export function TableErrorState({ title = "Unable to load records", description, action, colSpan = 1, className }: TableStateProps) {
  return (
    <tr>
      <td colSpan={colSpan}>
        <ErrorState variant="table" title={title} description={description} retryAction={action} className={className} />
      </td>
    </tr>
  );
}
